// Centralized Tour Guide Steps

export const SalesOrders_SalesOrderMasterTourSteps = [
    {
      target: '[data-tour="so-search"]',
      title: "Order Search",
      content: "Quickly locate specific sales orders by customer name or order number.",
      titleHi: "ऑर्डर खोज",
      contentHi: "ग्राहक का नाम या ऑर्डर नंबर डालकर विशिष्ट बिक्री ऑर्डर जल्दी से खोजें।",
      titleGu: "ઓર્ડર શોધ",
      contentGu: "ગ્રાહકનું નામ અથવા ઓર્ડર નંબર દાખલ કરીને ઝડપથી સેલ્સ ઓર્ડર શોધો.",
    },
    {
      target: '[data-tour="so-add"]',
      title: "Create Order",
      content: "Click here to generate a new Sales Order, specify alloys, and configure profile details.",
      titleHi: "नया ऑर्डर बनाएं",
      contentHi: "नया बिक्री ऑर्डर बनाने, अलॉय चुनने और प्रोफ़ाइल विवरण सेट करने के लिए यहाँ क्लिक करें।",
      titleGu: "નવો ઓર્ડર બનાવો",
      contentGu: "નવો સેલ્સ ઓર્ડર બનાવવા, એલોય પસંદ કરવા અને પ્રોફાઇલ વિગતો સેટ કરવા માટે અહીં ક્લિક કરો.",
    },
    {
      target: '[data-tour="so-table"]',
      title: "Order Registry",
      content: "View, edit, or delete existing sales orders. Track their status and delivery lead times.",
      titleHi: "ऑर्डर रजिस्ट्री",
      contentHi: "मौजूदा बिक्री ऑर्डर देखें, संपादित करें या हटाएं। उनकी स्थिति और डिलीवरी समय ट्रैक करें।",
      titleGu: "ઓર્ડર રજિસ્ટ્રી",
      contentGu: "હાલના સેલ્સ ઓર્ડર જુઓ, સંપાદિત કરો અથવા કાઢી નાખો. તેમની સ્થિતિ અને ડિલિવરી સમય ટ્રૅક કરો.",
    },
    {
      target: '[data-tour="so-footer"]',
      title: "Cumulative Metrics",
      content: "Monitor total production demand including aggregate pieces and weight requirements.",
      titleHi: "संचयी मेट्रिक्स",
      contentHi: "कुल पीस और वजन आवश्यकताओं सहित कुल उत्पादन मांग की निगरानी करें।",
      titleGu: "સંચિત મેટ્રિક્સ",
      contentGu: "કુલ ટુકડાઓ અને વજનની જરૂરિયાતો સહિત કુલ ઉત્પાદન માંગ પર નજર રાખો.",
    },
  ];

export const RawMaterial_MaterialInwardTourSteps = [
    {
      target: '[data-tour="mi-search"]',
      title: "Inward Search",
      content: "Find past raw material deliveries by their SKU number or supplier name.",
      titleHi: "आवक खोज",
      contentHi: "पिछले कच्चे माल की डिलीवरी को उनके SKU नंबर या सप्लायर के नाम से खोजें।",
      titleGu: "ઇનવર્ડ શોધ",
      contentGu: "અગાઉના કાચા માલની ડિલિવરી તેમના SKU નંબર અથવા સપ્લાયર નામ દ્વારા શોધો.",
    },
    {
      target: '[data-tour="mi-add"]',
      title: "Log New Inward",
      content: "Record a new receipt of raw materials. Upload invoices or weighbridge receipts directly.",
      titleHi: "नई आवक लॉग करें",
      contentHi: "कच्चे माल की नई रसीद दर्ज करें। चालान या धर्मकांटा रसीद सीधे अपलोड करें।",
      titleGu: "નવી ઇનવર્ડ નોંધો",
      contentGu: "કાચા માલની નવી રસીદ રેકોર્ડ કરો. ઇન્વૉઇસ અથવા વજનકાંટાની રસીદો સીધી અપલોડ કરો.",
    },
    {
      target: '[data-tour="mi-table"]',
      title: "Inward Ledger",
      content: "View the history of all materials received, including quantities and verified weights.",
      titleHi: "आवक बहीखाता",
      contentHi: "मात्रा और सत्यापित वजन सहित प्राप्त सभी सामग्रियों का इतिहास देखें।",
      titleGu: "ઇનવર્ડ લેજર",
      contentGu: "પ્રાપ્ત થયેલ તમામ સામગ્રીનો ઇતિહાસ જુઓ, જેમાં જથ્થો અને ચકાસાયેલ વજનનો સમાવેશ થાય છે.",
    },
  ];

export const RawMaterial_AllStocksTourSteps = [
    {
      target: '[data-tour="allstocks-summary"]',
      title: "Stock Summary",
      content: "View your entire inventory separated by category. See total quantity and average rates at a glance.",
      titleHi: "स्टॉक सारांश",
      contentHi: "श्रेणी के अनुसार अपनी पूरी इन्वेंट्री देखें। एक नज़र में कुल मात्रा और औसत दरें देखें।",
      titleGu: "સ્ટોક સારાંશ",
      contentGu: "શ્રેણી દ્વારા અલગ પડેલી તમારી સંપૂર્ણ ઇન્વેન્ટરી જુઓ. એક નજરમાં કુલ જથ્થો અને સરેરાશ દરો જુઓ.",
    },
    {
      target: '[data-tour="allstocks-table"]',
      title: "Category Details",
      content: "Detailed list of all SKUs, grades, and supplier quantities for the specific category.",
      titleHi: "श्रेणी विवरण",
      contentHi: "विशिष्ट श्रेणी के लिए सभी SKU, ग्रेड और आपूर्तिकर्ता मात्राओं की विस्तृत सूची।",
      titleGu: "શ્રેણી વિગતો",
      contentGu: "ચોક્કસ શ્રેણી માટે તમામ SKU, ગ્રેડ અને સપ્લાયર જથ્થાઓની વિગતવાર સૂચિ.",
    }
  ];

export const QCTourSteps = [
    {
      target: '[data-tour="qc-tabs"]',
      title: "Tab Navigation",
      content: "Toggle between 'QC Pending' to evaluate extruded profiles, and 'QC Done' to see historically logged quality records.",
      titleHi: "टैब नेविगेशन",
      contentHi: "'QC Pending' में एक्सट्रूड प्रोफाइल की जाँच करें और 'QC Done' में पुराने क्वालिटी रिकॉर्ड देखें।",
      titleGu: "ટૅબ નેવિગેશન",
      contentGu: "'QC Pending' માં એક્સ્ટ્રૂડ પ્રોફાઇલ ચકાસો અને 'QC Done' માં ઐતિહાસિક ગુણવત્તા નોંધ જુઓ.",
    },
    {
      target: '[data-tour="qc-search"]',
      title: "Casting & Die Filter",
      content: "Type in die numbers, casting batches, or order IDs to quickly isolate specific items.",
      titleHi: "कास्टिंग और डाई फ़िल्टर",
      contentHi: "डाई नंबर, कास्टिंग बैच या ऑर्डर आईडी टाइप करके विशेष आइटम खोजें।",
      titleGu: "કાસ્ટિંગ અને ડાઇ ફિલ્ટર",
      contentGu: "ડાઇ નંબર, કાસ્ટિંગ બૅચ અથવા ઓર્ડર આઇડી ટાઇપ કરીને ઝડપથી ચોક્કસ આઇટમ શોધો.",
    },
    {
      target: '[data-tour="qc-table"]',
      title: "Inspection Log Grid",
      content: "Input final QC pieces, stretching and butt end rejects, first/second weights, and remarks directly into this table.",
      titleHi: "निरीक्षण लॉग ग्रिड",
      contentHi: "इस टेबल में QC पीस, स्ट्रेचिंग/बट एंड रिजेक्ट, पहला/दूसरा वजन और टिप्पणियाँ भरें।",
      titleGu: "ઇન્સ્પેક્શન લૉગ ગ્રિડ",
      contentGu: "આ ટેબલમાં QC ટુકડા, સ્ટ્રેચિંગ/બટ-એન્ડ રિજેક્ટ, 1લું/2જું વજન અને ટિપ્પણી ભરો.",
    },
    {
      target: '[data-tour="qc-table"]',
      title: "Row Actions",
      content: "Click 'Edit' to unlock inputs. Once saved, if QC Pcs matches Produced Pcs, click 'Mark Done' to complete inspection.",
      titleHi: "रो ऐक्शन",
      contentHi: "इनपुट अनलॉक करने के लिए 'Edit' दबाएं। सेव होने के बाद अगर QC Pcs = Produced Pcs हो तो 'Mark Done' करें।",
      titleGu: "રો ઍક્શન",
      contentGu: "ઇનપુટ ખોલવા 'Edit' દબાવો. સેવ પછી જો QC Pcs = Produced Pcs હોય, તો 'Mark Done' ક્લિક કરો.",
    },
    {
      target: '[data-tour="qc-footer"]',
      title: "Inspection Metrics",
      content: "Monitor shift statistics including total production vs approved vs rejected pieces in the summary footer.",
      titleHi: "निरीक्षण मेट्रिक्स",
      contentHi: "फुटर में शिफ्ट के कुल उत्पादन, स्वीकृत और अस्वीकृत पीस देखें।",
      titleGu: "ઇન્સ્પેક્શન મેટ્રિક્સ",
      contentGu: "ફૂટરમાં શિફ્ટના કુલ ઉત્પાદન, સ્વીકૃત અને નકારેલ ટુકડા જુઓ.",
    },
  ];

export const PackingTourSteps = [
    {
      target: '[data-tour="packing-tabs"]',
      title: "View Modes",
      content: "Switch between 'Aging Done' to view metal items ready to be packed, and 'Packing Entry' to view and print stickers for packed bundles.",
      titleHi: "व्यू मोड",
      contentHi: "'Aging Done' में पैकिंग के लिए तैयार आइटम देखें और 'Packing Entry' में स्टिकर प्रिंट करें।",
      titleGu: "વ્યૂ મોડ",
      contentGu: "'Aging Done' માં પૅકિંગ માટે તૈયાર આઇટમ જુઓ અને 'Packing Entry' માં સ્ટિકર પ્રિન્ટ કરો.",
    },
    {
      target: '[data-tour="packing-search"]',
      title: "Quick Search",
      content: "Filter through available orders or packing status quickly by typing here.",
      titleHi: "तेज़ खोज",
      contentHi: "ज़ल्दी ऑर्डर या पैकिंग स्टेटस फ़िल्टर करें।",
      titleGu: "ઝડપ શોધ",
      contentGu: "ઑર્ડર અથવા પૅકિંગ સ્ટેટસ દ્વારા ઝડપથી ફિલ્ટર કરો.",
    },
    {
      target: '[data-tour="add-packing-btn"]',
      title: "Initialize Packing",
      content: "Select a row from the 'Aging Done' list and click 'ADD PACKING' to configure weights, bundle size, and series details in the form.",
      titleHi: "पैकिंग शुरू करें",
      contentHi: "'Aging Done' से एक रो चुनें और 'ADD PACKING' दबाएं।",
      titleGu: "પૅકિંગ શરૂ કરો",
      contentGu: "'Aging Done' માંથી એક રો પસંદ કરો અને 'ADD PACKING' દબાવો.",
    },
    {
      target: '[data-tour="packing-table"]',
      title: "Packing Records Grid",
      content: "View detailed statistics of packed units. In the Packing Entry view, use the 'EDIT' button to modify bundle weights or remarks.",
      titleHi: "पैकिंग रिकॉर्ड ग्रिड",
      contentHi: "पैक यूनिट की विस्तृत जानकारी देखें। 'EDIT' से बंडल वेट या टिप्पणी बदलें।",
      titleGu: "પૅકિંગ રેકોર્ડ ગ્રિડ",
      contentGu: "પૅક યૂનિટની વિગતવાર માહિતી જુઓ. 'EDIT' થી બંડલ વેટ કે ટિપ્પણી બદલો.",
    },
    {
      target: '[data-tour="print-sticker-btn"]',
      title: "Print Stickers",
      content: "Select one or more bundles from the 'Packing Entry' list, then click 'PRINT STICKER' to export the printable labels.",
      titleHi: "स्टिकर प्रिंट करें",
      contentHi: "'Packing Entry' से बंडल चुनें और 'PRINT STICKER' दबाएं।",
      titleGu: "સ્ટિકર પ્રિન્ટ કરો",
      contentGu: "'Packing Entry' માંથી બંડલ પસંદ કરો અને 'PRINT STICKER' દબાવો.",
    },
    {
      target: '[data-tour="packing-footer"]',
      title: "Shift Totals Summary",
      content: "Track cumulative pieces and total gross weight packed during your shift at a glance.",
      titleHi: "शिफ्ट कुल समरी",
      contentHi: "शिफ्ट के कुल पीस और ग्रोस वेट एक नज़र में देखें।",
      titleGu: "શિફ્ટ કુલ સરવૈયાં",
      contentGu: "શિફ્ટના કુલ ટુકડા અને ગ્રોસ વેટ એક નજરે જુઓ.",
    },
  ];

export const OrderPlanView_OrderPlanViewTourSteps = [
    {
      target: '[data-tour="plan-tabs"]',
      title: "View Modes",
      content: "Toggle between 'Sales Orders' to plan new batches, and 'Executed Orders' to view historical production batches.",
      titleHi: "व्यू मोड",
      contentHi: "नए बैच की योजना बनाने के लिए 'Sales Orders' और ऐतिहासिक उत्पादन बैच देखने के लिए 'Executed Orders' के बीच स्विच करें।",
      titleGu: "વ્યૂ મોડ",
      contentGu: "નવા બૅચની યોજના બનાવવા 'Sales Orders' અને ઐતિહાસિક ઉત્પાદન બૅચ જોવા 'Executed Orders' વચ્ચે ટૉગલ કરો.",
    },
    {
      target: '[data-tour="plan-search"]',
      title: "Order Filter",
      content: "Type to quickly search and filter the order planning list.",
      titleHi: "ऑर्डर फ़िल्टर",
      contentHi: "ऑर्डर प्लानिंग सूची को जल्दी से खोजने और फ़िल्टर करने के लिए टाइप करें।",
      titleGu: "ઑર્ડર ફિલ્ટર",
      contentGu: "ઑર્ડર પ્લાનિંગ સૂચિને ઝડપથી શોધવા અને ફિલ્ટર કરવા માટે ટાઇપ કરો.",
    },
    {
      target: '[data-tour="plan-table"]',
      title: "Selection Grid",
      content: "Select the checkboxes for multiple orders you wish to group into a single production batch.",
      titleHi: "चयन ग्रिड",
      contentHi: "उन कई ऑर्डरों के लिए चेकबॉक्स चुनें जिन्हें आप एक एकल उत्पादन बैच में समूहबद्ध करना चाहते हैं।",
      titleGu: "પસંદગી ગ્રિડ",
      contentGu: "બહુવિધ ઑર્ડર્સ માટે ચેકબૉક્સ પસંદ કરો જેને તમે એકલ ઉત્પાદન બૅચમાં જૂથબદ્ધ કરવા માંગો છો.",
    },
    {
      target: '[data-tour="plan-batch"]',
      title: "Create Batch",
      content: "After selecting orders, click here to group them into an executable production batch.",
      titleHi: "बैच बनाएं",
      contentHi: "ऑर्डर चुनने के बाद, उन्हें निष्पादन योग्य उत्पादन बैच में समूहित करने के लिए यहाँ क्लिक करें।",
      titleGu: "બૅચ બનાવો",
      contentGu: "ઑર્ડર પસંદ કર્યા પછી, તેમને એક્ઝિક્યુટેબલ ઉત્પાદન બૅચમાં જૂથબદ્ધ કરવા માટે અહીં ક્લિક કરો.",
    }
  ];

export const InProductionTourSteps = [
    {
      target: '[data-tour="die-registry"]',
      title: "Die Assets Registry",
      content: "Select one or more active dies by checking their boxes here. This will automatically load their production logs in the cards below.",
      titleHi: "डाई एसेट्स रजिस्ट्री",
      contentHi: "यहाँ ऐक्तिव डाई चुनें। आटोमेटिक नीचे उनके प्रोडक्शन लॉग लोड होंगे।",
      titleGu: "ડાઈ એસેટ્સ રજિસ્ટ્રી",
      contentGu: "અામાંઔથી સક્રિય ડાઈ પસંદ કરો. નીચે આપોઆપ તેમના ઉત્પાદન લૉગ લોડ થશે.",
      placement: "bottom"
    },
    {
      target: '[data-tour="production-workspace"]',
      title: "Production Workspace",
      content: "Once selected, each die shows as a Production Card down here. You can record timestamps, billet sizes, and run status inside these cards.",
      titleHi: "प्रोडक्शन वर्कस्पेस",
      contentHi: "उत्पादन कार्ड में तारीख, बिलेट साइज़ और रन स्टेटस दर्ज करें।",
      titleGu: "ઉત્પાદન વર્કસ્પેસ",
      contentGu: "પ્રોડક્શન કાર્ડમાં ટાઇમસ્ટેમ્પ, બિલેટ સાઇઝ અને રન સ્ટેટસ નોંધો.",
      placement: "top"
    },
    {
      target: '[data-tour="casting-no"]',
      title: "1. Select Casting Number",
      content: "Choose the active Casting Number for the metal billets you are loading. This is required to track material batches correctly.",
      titleHi: "1. कास्टिंग नंबर चुनें",
      contentHi: "जिस धातु बिलेट का उपयोग हो रहा है उसका कास्टिंग नंबर चुनें। मटेरियल बैच ट्रैक करने के लिए ज़रूरी है।",
      titleGu: "1. કાસ્ટિંગ નંબર પસંદ કરો",
      contentGu: "લોડ કરાતા બિલેટના કાસ્ટિંગ નંબર ભરો. માલ બૅચ સાચી રીતે ટ્રૅક કરવા જરૂરી છે.",
      placement: "bottom"
    },
    {
      target: '[data-tour="billet-spec"]',
      title: "2. Set Billet Details",
      content: "Enter the Billet Size and the total Number of Billets used. The system will automatically calculate the Input Weight for you.",
      titleHi: "2. बिलेट विवरण सेट करें",
      contentHi: "बिलेट साइज़ और कुल संख्या भरें। सिस्टम इनपुट वेट आटोमेटिक कैलकुलेट करेगा।",
      titleGu: "2. બિલેટ વિગત સેટ કરો",
      contentGu: "બિલેટ સાઇઝ અને કુલ સંખ્યા ભરો. સિસ્ટમ આપોઆપ ઇનપુટ વેટ ગણશે.",
      placement: "bottom"
    },
    {
      target: '[data-tour="pcs-needed"]',
      title: "3. Target Pieces",
      content: "Enter the number of pieces required. The system will compare your target and actual pieces dynamically to keep runs optimized.",
      titleHi: "3. लक्ष्य पीस",
      contentHi: "ज़रूरी पीस की संख्या दर्ज करें। सिस्टम लक्ष्य और वास्तविक पीस की तुलना करेगा।",
      titleGu: "3. ટારગેટ ટુકડા",
      contentGu: "જરૂરી ટુકડાની સંખ્યા નોંધો. સિસ્ટમ લક્ષ્ય અને વાસ્તવિક ટુકડાની સરખામણી કરશે.",
      placement: "bottom"
    },
    {
      target: '[data-tour="output-logging"]',
      title: "4. Enter Production Results",
      content: "Once extrusion is done, enter the actual Number of Pieces produced and total Output Weight. The system will immediately compute your Recovery percentage!",
      titleHi: "4. उत्पादन परिणाम दर्ज करें",
      contentHi: "एक्सट्रूशन होने के बाद वास्तविक पीस और आउटपुट वेट दर्ज करें। रिकवरी प्रतिशत तुरंत कैलकुलेट होगा।",
      titleGu: "4. ઉત્પાદન પરિણામ નોંધો",
      contentGu: "એક્સ્ટ્રૂશન પત્યા બાદ વાસ્તવિક ટુકડા અને આઉટપુટ વેટ નોંધો. રિકવરી % તરત ગણાશે.",
      placement: "bottom"
    },
    {
      target: '[data-tour="actions-menu"]',
      title: "5. Select Cycle Action",
      content: "Use this menu to execute a Billet Change (exchanging billet logs), a Die Unload (removing the die from the press with a reason), or Mark Done (completing production).",
      titleHi: "5. साईकल ऐक्शन चुनें",
      contentHi: "इस मेनू से Billet Change, Die Unload या Mark Done चुनें।",
      titleGu: "5. સાઇકલ ઍક્શન પસંદ કરો",
      contentGu: "આ મેનૂમાંથી Billet Change, Die Unload અથવા Mark Done પસંદ કરો.",
      placement: "left"
    },
    {
      target: '[data-tour="log-production-btn"]',
      title: "6. Save Your Progress",
      content: "Click LOG PRODUCTION to submit and save this run's metrics to the database. (If doing a Billet Change, this button confirms the protocol).",
      titleHi: "6. प्रगति सेव करें",
      contentHi: "LOG PRODUCTION दबाकर इस रन के डेटा सेव करें।",
      titleGu: "6. પ્રગતિ સેવ કરો",
      contentGu: "LOG PRODUCTION દબાવી આ રનના ડેટા સેવ કરો.",
      placement: "left"
    },
    {
      target: '[data-tour="calculation-footer"]',
      title: "Metrics Summary Footer",
      content: "Look down here at the bottom footer to view total finished pieces and total cumulative weight logged during your shift.",
      titleHi: "मेट्रिक्स समरी फुटर",
      contentHi: "नीचे फुटर में शिफ्ट के कुल पीस और कुल वजन देखें।",
      titleGu: "મેટ્રિક્સ સરવૈયા ફૂટર",
      contentGu: "નીચે ફૂટરમાં શિફ્ટના કુલ ટુકડા અને કુલ વજન જુઓ.",
      placement: "top"
    }
  ];

export const Foundry_FoundryMasterTourSteps = [
    {
      target: '[data-tour="foundry-search"]',
      title: "Casting Search",
      content: "Search through previous casting logs by their Casting Number or Furnace Name.",
      titleHi: "कास्टिंग खोज",
      contentHi: "कास्टिंग नंबर या फर्नेस के नाम से पुराने कास्टिंग लॉग में खोजें।",
      titleGu: "કાસ્ટિંગ શોધ",
      contentGu: "કાસ્ટિંગ નંબર અથવા ફર્નેસ નામ દ્વારા અગાઉના કાસ્ટિંગ લોગમાં શોધો.",
    },
    {
      target: '[data-tour="foundry-add"]',
      title: "New Foundry Log",
      content: "Click to record a new casting cycle, track furnace times, fuel usage, scrap entry, and spectro results.",
      titleHi: "नया फाउंड्री लॉग",
      contentHi: "नई कास्टिंग साइकिल दर्ज करने, फर्नेस का समय, ईंधन उपयोग, स्क्रैप एंट्री और स्पेक्ट्रो परिणाम ट्रैक करने के लिए क्लिक करें।",
      titleGu: "નવો ફાઉન્ડ્રી લોગ",
      contentGu: "નવી કાસ્ટિંગ સાયકલ રેકોર્ડ કરવા, ફર્નેસનો સમય, બળતણનો ઉપયોગ, સ્ક્રેપ એન્ટ્રી અને સ્પેક્ટ્રો પરિણામો ટ્રેક કરવા માટે ક્લિક કરો.",
    },
    {
      target: '[data-tour="foundry-table"]',
      title: "Foundry Ledger",
      content: "View all recorded casting batches. You can edit a batch if you need to update fuel readings or spectro lab results.",
      titleHi: "फाउंड्री बहीखाता",
      contentHi: "सभी दर्ज कास्टिंग बैच देखें। यदि आपको ईंधन रीडिंग या स्पेक्ट्रो लैब परिणामों को अपडेट करने की आवश्यकता है, तो आप बैच को संपादित कर सकते हैं।",
      titleGu: "ફાઉન્ડ્રી લેજર",
      contentGu: "તમામ નોંધાયેલા કાસ્ટિંગ બેચ જુઓ. જો તમારે બળતણ રીડિંગ્સ અથવા સ્પેક્ટ્રો લેબ પરિણામો અપડેટ કરવાની જરૂર હોય, તો તમે બેચને સંપાદિત કરી શકો છો.",
    },
  ];

export const DiePurchaseOrder_DiePurchaseOrderMasterTourSteps = [
        {
            target: '[data-tour="diepo-tabs"]',
            title: "View Modes",
            content: "Switch between 'PO History' to see all ordered dies, and 'Pending Inward' to process new dies as they arrive.",
            titleHi: "व्यू मोड",
            contentHi: "सभी ऑर्डर की गई डाई देखने के लिए 'PO History' और नई आने वाली डाई को प्रोसेस करने के लिए 'Pending Inward' के बीच स्विच करें।",
            titleGu: "વ્યૂ મોડ",
            contentGu: "બધા ઓર્ડર કરેલા ડાઈ જોવા માટે 'PO History' અને નવા આવતા ડાઈની પ્રક્રિયા કરવા માટે 'Pending Inward' વચ્ચે સ્વિચ કરો.",
        },
        {
            target: '[data-tour="diepo-search"]',
            title: "Quick Filter",
            content: "Search through purchase orders by PO Number or Supplier Name.",
            titleHi: "त्वरित फ़िल्टर",
            contentHi: "PO नंबर या आपूर्तिकर्ता के नाम से खरीद आदेशों के माध्यम से खोजें।",
            titleGu: "ઝડપી ફિલ્ટર",
            contentGu: "PO નંબર અથવા સપ્લાયર નામ દ્વારા ખરીદી ઓર્ડરમાં શોધો.",
        },
        {
            target: '[data-tour="diepo-add"]',
            title: "Create New PO",
            content: "Click here to generate a new Purchase Order for dies from a supplier.",
            titleHi: "नया PO बनाएँ",
            contentHi: "आपूर्तिकर्ता से डाई के लिए नया खरीद आदेश उत्पन्न करने के लिए यहाँ क्लिक करें।",
            titleGu: "નવો PO બનાવો",
            contentGu: "સપ્લાયર પાસેથી ડાઈ માટે નવો ખરીદી ઓર્ડર બનાવવા માટે અહીં ક્લિક કરો.",
        },
        {
            target: '[data-tour="diepo-table"]',
            title: "PO Details",
            content: "Expand any row to see individual die items attached to the purchase order, including weights, drawings, and invoice data.",
            titleHi: "PO विवरण",
            contentHi: "खरीद आदेश से जुड़े व्यक्तिगत डाई आइटम देखने के लिए किसी भी पंक्ति का विस्तार करें, जिसमें वज़न, चित्र और चालान डेटा शामिल हैं।",
            titleGu: "PO વિગતો",
            contentGu: "વજન, ડ્રોઇંગ અને ઇન્વૉઇસ ડેટા સહિત ખરીદી ઓર્ડર સાથે જોડાયેલ વ્યક્તિગત ડાઈ આઇટમ્સ જોવા માટે કોઈપણ રો વિસ્તૃત કરો.",
        }
    ];

export const DieManagement_DieAllocationTourSteps = [
    {
      target: '[data-tour="alloc-tabs"]',
      title: "View Modes",
      content: "Toggle between 'Die Preparation' for dies awaiting heat treatment, and 'Send to Oven' for dies currently being heated.",
      titleHi: "व्यू मोड",
      contentHi: "हीट ट्रीटमेंट की प्रतीक्षा कर रही डाई के लिए 'Die Preparation' और वर्तमान में हीट की जा रही डाई के लिए 'Send to Oven' के बीच टॉगल करें।",
      titleGu: "વ્યૂ મોડ",
      contentGu: "હીટ ટ્રીટમેન્ટની રાહ જોઈ રહેલી ડાઈ માટે 'Die Preparation' અને હાલમાં હીટ કરવામાં આવતી ડાઈ માટે 'Send to Oven' વચ્ચે ટૉગલ કરો.",
    },
    {
      target: '[data-tour="alloc-search"]',
      title: "Die Filter",
      content: "Type to quickly search and filter the die allocation list.",
      titleHi: "डाई फ़िल्टर",
      contentHi: "डाई आवंटन सूची को जल्दी से खोजने और फ़िल्टर करने के लिए टाइप करें।",
      titleGu: "ડાઈ ફિલ્ટર",
      contentGu: "ડાઈ ફાળવણી સૂચિને ઝડપથી શોધવા અને ફિલ્ટર કરવા માટે ટાઇપ કરો.",
    },
    {
      target: '[data-tour="alloc-table"]',
      title: "Die Selection",
      content: "Select the checkboxes for multiple dies you wish to send to the oven simultaneously.",
      titleHi: "डाई चयन",
      contentHi: "उन कई डाइयों के लिए चेकबॉक्स चुनें जिन्हें आप एक साथ ओवन में भेजना चाहते हैं।",
      titleGu: "ડાઈ પસંદગી",
      contentGu: "બહુવિધ ડાઈ માટે ચેકબોક્સ પસંદ કરો જેને તમે એકસાથે ઓવનમાં મોકલવા માંગો છો.",
    },
    {
      target: '[data-tour="alloc-issue"]',
      title: "Issue To Oven",
      content: "After selecting dies, click here to officially mark them as 'Sent to Oven'.",
      titleHi: "ओवन को जारी करें",
      contentHi: "डाई चुनने के बाद, उन्हें आधिकारिक तौर पर 'ओवन में भेजा गया' चिह्नित करने के लिए यहाँ क्लिक करें।",
      titleGu: "ઓવનને ઇશ્યૂ કરો",
      contentGu: "ડાઈ પસંદ કર્યા પછી, સત્તાવાર રીતે તેમને 'ઓવનમાં મોકલ્યા' તરીકે ચિહ્નિત કરવા માટે અહીં ક્લિક કરો.",
    }
  ];

export const DieManagement_DieMasterTourSteps = [
    {
      target: '[data-tour="die-search"]',
      title: "Die Database Search",
      content: "Instantly locate any die by typing its ID, profile, or customer name here.",
      titleHi: "डाई डेटाबेस खोज",
      contentHi: "किसी भी डाई को उसका आईडी, प्रोफ़ाइल या ग्राहक का नाम टाइप करके तुरंत खोजें।",
      titleGu: "ડાઈ ડેટાબેઝ શોધ",
      contentGu: "અહીં તેનું ID, પ્રોફાઇલ અથવા ગ્રાહકનું નામ ટાઇપ કરીને કોઈપણ ડાઇ તરત જ શોધો.",
    },
    {
      target: '[data-tour="die-add"]',
      title: "Register New Die",
      content: "Click to record a newly acquired die, complete with its technical specs, weights, and PDF drawing.",
      titleHi: "नई डाई रजिस्टर करें",
      contentHi: "नई डाई को उसकी तकनीकी विशिष्टताओं, वज़न और PDF ड्राइंग के साथ दर्ज करने के लिए क्लिक करें।",
      titleGu: "નવી ડાઈ રજીસ્ટર કરો",
      contentGu: "નવી ડાઈને તેની તકનીકી વિશેષતાઓ, વજન અને પીડીએફ ડ્રોઇંગ સાથે રેકોર્ડ કરવા માટે ક્લિક કરો.",
    },
    {
      target: '[data-tour="die-export"]',
      title: "Merge PDF Export",
      content: "Select multiple dies using the checkboxes, then click 'Download PDF' to merge and download all their drawings as a single file.",
      titleHi: "पीडीएफ एक्सपोर्ट को मर्ज करें",
      contentHi: "चेकबॉक्स का उपयोग करके कई डाई चुनें, फिर उनके सभी चित्र एक ही फ़ाइल के रूप में डाउनलोड करने के लिए 'Download PDF' पर क्लिक करें।",
      titleGu: "પીડીએફ એક્સપોર્ટ મર્જ કરો",
      contentGu: "ચેકબોક્સનો ઉપયોગ કરીને બહુવિધ ડાઈ પસંદ કરો, પછી તે બધાના ચિત્રો એક જ ફાઇલમાં ડાઉનલોડ કરવા માટે 'Download PDF' પર ક્લિક કરો.",
    },
    {
      target: '[data-tour="die-table"]',
      title: "Die Inventory Grid",
      content: "View all active dies. You can sort by columns, filter specific fields, edit properties, or download individual PDFs directly from this list.",
      titleHi: "डाई इन्वेंटरी ग्रिड",
      contentHi: "सभी सक्रिय डाई देखें। आप कॉलम द्वारा सॉर्ट कर सकते हैं, फ़िल्टर कर सकते हैं, गुण संपादित कर सकते हैं, या सीधे यहाँ से पीडीएफ डाउनलोड कर सकते हैं।",
      titleGu: "ડાઈ ઇન્વેન્ટરી ગ્રિડ",
      contentGu: "બધી સક્રિય ડાઈ જુઓ. તમે કૉલમ દ્વારા સૉર્ટ કરી શકો છો, ફિલ્ટર કરી શકો છો, ગુણધર્મોને સંપાદિત કરી શકો છો અથવા સીધા અહીંથી પીડીએફ ડાઉનલોડ કરી શકો છો.",
    }
  ];

export const AgingTourSteps = [
    {
      target: '[data-tour="aging-tabs"]',
      title: "View Modes Toggle",
      content: "Switch between 'Aging Pending' (to view elements awaiting thermal treatment) and 'Aging Done' (to view active or complete heat records).",
      titleHi: "व्यू मोड टॉगल",
      contentHi: "'Aging Pending' में थर्मल ट्रीटमेंट के इंतज़ार आइटम देखें और 'Aging Done' में पूरे हिट रिकॉर्ड देखें।",
      titleGu: "વ્યૂ મોડ ટોગલ",
      contentGu: "'Aging Pending' માં ઔષ્મિક સારવારની રાહમાં રહેલા આઇટમ જુઓ અને 'Aging Done' માં પૂરા હીટ રેકોર્ડ જુઓ.",
    },
    {
      target: '[data-tour="aging-search"]',
      title: "Quick Search Filter",
      content: "Quickly filter rows by batch, order number, or casting run.",
      titleHi: "तेज़ खोज फ़िल्टर",
      contentHi: "बैच, ऑर्डर नंबर या कास्टिंग रन से ज़ल्दी फ़िल्टर करें।",
      titleGu: "ઝડપ શોધ ફિલ્ટર",
      contentGu: "બૅચ, ઓર્ડર નંબર કે કાસ્ટિંગ રન થી ઝડપથી ફિલ્ટર કરો.",
    },
    {
      target: '[data-tour="add-aging-btn"]',
      title: "Create Aging Cycle",
      content: "Select one or more items from 'Aging Pending' and click 'ADD AGING' to load their details and configure thermal times and gas metrics.",
      titleHi: "एजिंग साईकल बनाएं",
      contentHi: "'Aging Pending' से आइटब चुनें और 'ADD AGING' दबाएं।",
      titleGu: "એજિંગ સાઇકલ બનાવો",
      contentGu: "'Aging Pending' માંથી આઇટમ પસંદ કરો અને 'ADD AGING' દબાવો.",
    },
    {
      target: '[data-tour="aging-table"]',
      title: "Thermal Log Grid",
      content: "Log start/end gas readings, shift details, oven temperature, in/out timestamps, and record hardness values.",
      titleHi: "थर्मल लॉग ग्रिड",
      contentHi: "गैस रीडिंग, शिफ्ट, ओवन तापमान, इन/आउट समय और हार्डनेस दर्ज करें।",
      titleGu: "ઔષ્મિક લૉગ ગ્રિડ",
      contentGu: "ગેસ રીડિંગ, શિફ્ટ, ઓવન તાપમાન, ઇન/આઉટ સમય અને હાર્ડનેસ નોંધો.",
    },
    {
      target: '[data-tour="aging-table"]',
      title: "Inline Cycle Actions",
      content: "Use 'Edit' to alter gas or timestamps, and 'Mark Done' when hardness checks are complete to finalize the cycle.",
      titleHi: "इनलाइन साईकल ऐक्शन",
      contentHi: "'Edit' से गैस या टाइमस्टैम्प बदलें और हार्डनेस जाँच पूरी होने पर 'Mark Done' करें।",
      titleGu: "ઇનલાઇન સાઇકલ ઍક્શન",
      contentGu: "'Edit' થી ગેસ કે ટાઇમસ્ટેમ્પ બદલો અને હાર્ડનેસ તપાસ પત્યા બાદ 'Mark Done' કરો.",
    },
    {
      target: '[data-tour="aging-footer"]',
      title: "Pending Pcs Summary",
      content: "Monitor total pending pieces and selected quantities waiting to be heat-treated during your shift.",
      titleHi: "पेंडिंग पीस समरी",
      contentHi: "शिफ्ट के कुल पेंडिंग पीस और चयनित मात्रा मॉनिटर करें।",
      titleGu: "પેન્ડિંગ ટુકડા સરવૈયાં",
      contentGu: "શિફ્ટના કુલ પેન્ડિંગ ટુકડા અને પસંદ કરાયેલી માતભા જુઓ.",
    },
  ];

